import { render, staticRenderFns } from "./CreateLayette.vue?vue&type=template&id=732ad4c2"
import script from "./CreateLayette.vue?vue&type=script&lang=js"
export * from "./CreateLayette.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports